export const usersQueryKeys = {
	all: ["users"] as const,
	details: () => [...usersQueryKeys.all, "details"] as const,
	me: () => [...usersQueryKeys.details(), "me"] as const,
	profile: () => [...usersQueryKeys.details(), "profile"] as const,
	assignable: () => [...usersQueryKeys.all, "assignable"] as const,
	duneSignatories: () => [...usersQueryKeys.all, "dune-signatories"] as const,
};
